/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_ART_MARGINS_ITEM = {
  id: 'products_margins',
  screenId: 'met-art-margins',
  label: 'Margen de productos',
  description: 'Rentabilidad bruta por artículo según costo de compra imputado (FIFO).',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Comparás qué productos dejan más margen en pesos y en porcentaje. El cálculo usa ventas con baja de stock y compras con remito imputado a factura.',
      },
      {
        title: 'Antes de empezar',
        bullets: [
          'Solo incluye artículos de compra-venta con movimiento de stock trazable.',
          'Si faltan remitos de compra o costos, algunas líneas quedan sin margen calculable.',
        ],
      },
      {
        title: 'Paso 1 — Elegir período',
        bullets: [
          'Atajos: Hoy, Semana, Mes, Mes anterior o Personalizado (desde / hasta + Aplicar).',
          'Arriba del gráfico ves cuántas líneas tienen costo asignado y cuántas no.',
        ],
      },
      {
        title: 'Paso 2 — Leer los gráficos',
        bullets: [
          'Mayor y menor margen bruto total ($) — diferencia en pesos entre venta neta y costo imputado.',
          'Mayor y menor margen bruto (%) — rentabilidad relativa sobre la venta.',
          'Cada barra corresponde a un artículo.',
        ],
      },
    ],
  },
}
